import { isEmpty } from "lodash-es";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

/**
 * A filter which removes non collections and empty collections.
 *
 * ```ts
 * this.store.pipe(select(this.selector.getCollectionOrUndefined()), ignoreEmpty())
 * ```
 * It is possible to set properties on primitives in regular javascript, they behave as objects
 * However in TypeScript you can not do it without enforcing types
 * Thus input can not be boolean | number
 * Also as of 10/03/2019 TypeScript does not support negated types nor excluding values from primitive types
 * Thus it is not possible to create a NonEmptyMap, NonEmptyArrayLike... and so on
 *
 * @return An Observable that only emits collections with at least one member.
 */
export const ignoreEmpty =
	() =>
	<T>(source: Observable<T>) =>
		source.pipe(
			filter((input): input is Exclude<T, undefined | null | boolean | number | symbol> => !isEmpty(input))
		);
